import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client, { TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = comprobando, false = sin sesión, obj = con sesión
    const [settings, setSettings] = useState(null);

    const loadMe = useCallback(async () => {
        try {
            const { data } = await client.get("/auth/me");
            setUser(data.user);
        } catch (e) {
            setUser(false);
        }
    }, []);

    useEffect(() => {
        loadMe();
        client.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => {});
    }, [loadMe]);

    const login = async (email, password) => {
        const { data } = await client.post("/auth/login", { email, password });
        localStorage.setItem(TOKEN_KEY, data.access_token);
        setUser(data.user);
        return data.user;
    };

    const register = async (name, email, password) => {
        const { data } = await client.post("/auth/register", { name, email, password });
        localStorage.setItem(TOKEN_KEY, data.access_token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try {
            await client.post("/auth/logout");
        } catch (e) {}
        localStorage.removeItem(TOKEN_KEY);
        setUser(false);
    };

    const refreshUser = loadMe;

    return (
        <AuthContext.Provider value={{ user, settings, login, register, logout, refreshUser, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
